/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Section } from '../../components/Section';
import { Paper, Table, TableHead, TableBody, TableCell, TableRow, TableContainer, Button, Typography, Modal, Box } from '@mui/material';
import useFreebiesQuery from './gql/freebies';
import useErrorHandler from '../../utils/userErrorHandler';
import useDeleteFreebieMutation from './gql/deleteFreebie';

const FreeContentsPage: React.FC = () => {
    const freebiesResp = useFreebiesQuery();
    const [deleteFreebie, deletedFreebieResp] = useDeleteFreebieMutation();

    useErrorHandler(freebiesResp.error, deletedFreebieResp.error);

    const [selected, setSelected] = useState<number>();
    const [modalOpen, setModalOpen] = useState(false);

    const handleModal = (id: number) => {
        setModalOpen(true);
        setSelected(id);
    };

    const handleDelete = async () => {
        await deleteFreebie({ id: selected });
        freebiesResp.refetch();
        setModalOpen(false);
    };

    return (
        <Paper css={containerStyles} elevation={0}>
            <Section title="Ingyenes anyagok">
                <TableContainer>
                    <Table aria-label="table" style={{ minWidth: 1310 }}>
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">ID</TableCell>
                                <TableCell align="center">Név</TableCell>
                                <TableCell align="center">Leírás</TableCell>
                                <TableCell align="center">Webinar azonosító</TableCell>
                                <TableCell align="center">Feliratkozók száma</TableCell>
                                <TableCell align="center">Létrehozás dátuma</TableCell>
                                <TableCell align="center">Műveletek</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {freebiesResp.data &&
                                freebiesResp.data.map((content) => (
                                    <TableRow css={trStyles} key={content.id}>
                                        <TableCell align="center">{content.id}</TableCell>
                                        <TableCell align="center">{content.name}</TableCell>
                                        <TableCell align="center" style={{ width: '25%' }}>
                                            {content.description ? content.description : ''}
                                        </TableCell>
                                        <TableCell align="center">{content.webinar_id ? content.webinar_id : '-'}</TableCell>
                                        <TableCell align="center"> {content.subscribers} </TableCell>
                                        <TableCell align="center"> {content.created_at} </TableCell>

                                        <TableCell align="center" css={actionsColStyles} style={{ width: '365px' }}>
                                            <Button variant="contained" color="error" onClick={() => handleModal(content.id)}>
                                                Törlés
                                            </Button>
                                            <Link to={`/marketing/free-content/${content.id}/edit`} style={{ textDecoration: 'none' }}>
                                                <Button variant="contained" color="primary">
                                                    Szerkesztés
                                                </Button>
                                            </Link>
                                            <Link to={`/marketing/free-content/${content.id}/details`} style={{ textDecoration: 'none' }}>
                                                <Button variant="contained" color="primary">
                                                    Megtekintés
                                                </Button>
                                            </Link>
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Link to="/marketing/free-content/create" css={buttonContainerStyles}>
                    <Button variant="contained" color="success">
                        Új hozzáadása
                    </Button>
                </Link>
            </Section>
            <Modal open={modalOpen} onClose={() => setModalOpen(false)} aria-labelledby="delete-modal-title" aria-describedby="delete-modal-description">
                <Box css={boxStyles}>
                    <Typography id="delete-modal-title" variant="h6" component="h2" style={{ marginBottom: '1rem' }}>
                        Biztosan törölni szeretnéd az ingyenes anyagot?
                    </Typography>
                    <div css={modalButtonContainerStyles}>
                        <Button size="large" variant="contained" color="error" onClick={handleDelete}>
                            Igen
                        </Button>
                        <Button size="large" variant="contained" onClick={() => setModalOpen(false)}>
                            Nem
                        </Button>
                    </div>
                </Box>
            </Modal>
        </Paper>
    );
};

const containerStyles = css`
    position: relative;
    max-width: 1500px;
    display: flex;
    flex-direction: column;
    padding: 0 1rem;
    margin: auto;
    margin-bottom: 25px;
    margin-top: 25px;
    gap: 25px;
`;

const trStyles = css`
    &: nth-of-type(odd) {
        background-color: #e3f2fd;
    }

    &:last-child td,
    &:last-child th {
        border: 0;
    }
`;

const actionsColStyles = css`
    & > * + * {
        margin-left: 10px !important;
    }
`;

const buttonContainerStyles = css`
    text-decoration: none;
    margin-left: auto;
    margin-right: 20px;
    margin-top: 20px;
    margin-bottom: 20px;
`;

const boxStyles = css`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    border: 2px solid #0288d1;
    boxshadow: 24;
    padding: 1rem;
`;

const modalButtonContainerStyles = css`
    display: flex;
    justify-content: space-evenly;
    margin-top: 1rem;
`;

export default FreeContentsPage;
